import FlexTableRow from '@/components/FlexTableRow';
import ShowNoDataDescription from '@/components/ShowNoDataDescription';
import { StyledTableRow } from '@/components/StyledTableRow';
import WideTableCell from '@/components/WideTableCell';
import { style } from '@/styles/globals';
import { convertMoney } from '@/utils/convertMoney';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import { styled } from '@mui/system';
import { isEmpty, uniqueId } from 'lodash';
import moment from 'moment';
import React from 'react';

const CTABooking = styled('div')`
  ${style.text.content.bold}
  text-align: center;
  color: ${style.color.product3};
  cursor:pointer;
`;
export default function FareInWeek({ days, onSearchFlight, isDesktop }: any) {
  return (
    <TableContainer
      component={Paper}
      sx={{
        minHeight: '50px',
        mt: '8px',
        boxShadow: 'none',
      }}
    >
      <Table
        sx={{}}
        aria-label="simple table"
      >
        <TableHead>
          <FlexTableRow
            sx={{
              background: 'white',
              border: 0,
            }}
          >
            <WideTableCell
              align="center"
              sx={{ whiteSpace: 'nowrap' }}
            >
              Ngày
              {' '}
              {isDesktop ? '' : 'giờ'}
              {' '}
              khởi hành
            </WideTableCell>
            {isDesktop && (
            <WideTableCell
              align="center"
              sx={{ whiteSpace: 'nowrap' }}
            >
              Giờ
            </WideTableCell>
            )}
            <WideTableCell
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            >
              Giá rẻ nhất
            </WideTableCell>
            {isDesktop && (
            <WideTableCell
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            />

            )}
          </FlexTableRow>
        </TableHead>
        <TableBody>
          {!isEmpty(days) ? days.slice(0, 7).map((row: any) => (
            <StyledTableRow
              key={uniqueId()}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <WideTableCell align="center">
                <div>{moment(row.date).format('DD/MM')}</div>
                {!isDesktop && (
                <div style={{ fontWeight: 'bold' }}>{row.time}</div>

                )}
              </WideTableCell>
              {isDesktop && (
              <WideTableCell align="center">
                <div style={{ fontWeight: 'bold' }}>{row.time}</div>
              </WideTableCell>
              )}
              <WideTableCell
                sx={{
                  fontWeight: '500',
                }}
                align="center"
              >
                {row?.averageMinfare
                  ? convertMoney(row?.averageMinfare)
                  : 'Đang cập nhật'}
                { !isDesktop && row?.averageMinfare && (
                  <CTABooking
                    onClick={() => onSearchFlight({
                      depart: moment(row.date).toISOString(),
                      return: null,
                    })}
                  >
                    Đặt vé
                  </CTABooking>
                )}
              </WideTableCell>
              {isDesktop && (
              <WideTableCell
                sx={{
                  fontWeight: '500',
                }}
                align="center"
              >
                { row?.averageMinfare && (
                <CTABooking
                  onClick={() => onSearchFlight({
                    depart: moment(row.date).toISOString(),
                    return: null,
                  })}
                >
                  Đặt vé
                </CTABooking>
                )}
              </WideTableCell>
              )}
              {/* <WideTableCell align="center">
                {row?.airline?.name ? (
                  <>
                    <div>{row?.airline?.name}</div>
                    <CTABooking onClick={() => onSelectTrip(row)}>
                      Đặt vé
                    </CTABooking>
                  </>
                ) : (
                  'Đang cập nhật'
                )}
              </WideTableCell> */}
            </StyledTableRow>
          )) : <ShowNoDataDescription />}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
